import { useState } from "react";
import { Printer, Store, Trash2 } from "lucide-react";
import { useT } from "@/i18n";
import { BIZ_TEXT } from "@/components/business/products";
import BusinessPoster from "@/components/business/BusinessPoster";

export default function MyBusinesses({ ideas, onDelete }) {
  const { lang } = useT();
  const [poster, setPoster] = useState(null);
  if (!ideas.length) return null;
  return (
    <div className="mt-8" data-testid="biz-my-list">
      <h3 className="font-fredoka text-xl font-bold text-blue-950 flex items-center gap-2">
        <Store className="w-6 h-6" /> {BIZ_TEXT[lang].mine}
      </h3>
      <div className="mt-3 flex flex-wrap gap-3">
        {ideas.map((idea) => (
          <div key={idea.id} className="bg-white rounded-2xl px-4 py-3 shadow-md flex items-center gap-3" data-testid={`biz-saved-${idea.id}`}>
            <div>
              <p className="font-fredoka font-bold text-blue-950">{idea.name}</p>
              <p className="text-xs text-blue-900/70 font-semibold">{idea.product}</p>
            </div>
            <button type="button" onClick={() => setPoster(idea)} className="inline-flex items-center gap-1 bg-yellow-300 rounded-full px-3 py-1 text-xs font-bold text-blue-950 hover:bg-yellow-400" data-testid={`biz-poster-${idea.id}`}>
              <Printer className="w-3.5 h-3.5" /> {lang === "en" ? "Poster" : "Cartel"}
            </button>
            <button type="button" onClick={() => onDelete(idea.id)} className="text-rose-500 hover:text-rose-700" aria-label="delete" data-testid={`biz-delete-${idea.id}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      {poster && <BusinessPoster idea={poster} onClose={() => setPoster(null)} />}
    </div>
  );
}
